import { useState } from "react";
import { MoreHorizontalIcon } from "lucide-react";
import moment from 'moment';
import Section from "../Section";
import BannerSectionStyle2 from "../Section/BannerSection/BannerSectionStyle2";
import AdminTable, { cellClass } from "../Admin/AdminTable";
import { getBookings } from "../../helpers/lib/axios";
import { useApiList } from "../../helpers/lib/useApiData";

const DetailRow = ({ label, value }) => (
    <div>
        <h3 className="text-lg font-medium text-gray-700 mb-1">{label}</h3>
        <p className="text-gray-600 mt-0">{value || "N/A"}</p>
    </div>
);

const Bookings = () => {
    const { items, loading, error } = useApiList(getBookings, 'Failed to load bookings.');
    const [selectedBooking, setSelectedBooking] = useState(null);

    const createdAt = selectedBooking?.createdAt && moment(selectedBooking.createdAt);

    return (<>
        <BannerSectionStyle2
            bgUrl="/images/about/banner_bg.svg"
            imgUrl="/images/about/banner_img.png"
            title="Bookings"
            subTitle="Appointments information"
        />
        <Section
            topMd={170}
            topLg={150}
            topXl={110}
            bottomMd={200}
            bottomLg={150}
            bottomXl={110}
            className='flex justify-center items-center w-full'
        >
            <div className="lg:max-w-[70%] w-full mt-[5%] p-4">
                <AdminTable
                    columns={['Name', 'Email', 'Gender', 'City', 'Age', 'Marital Status', 'Actions']}
                    items={items}
                    loading={loading}
                    error={error}
                    emptyText="No bookings yet."
                    getKey={(booking) => booking?._id}
                    renderRow={(booking) => (<>
                        <td className={cellClass}>{booking?.userDetails?.name}</td>
                        <td className={cellClass}>{booking?.userDetails?.email}</td>
                        <td className={cellClass}>{booking?.userDetails?.gender}</td>
                        <td className={cellClass}>{booking?.userDetails?.cityOfResidence}</td>
                        <td className={cellClass}>{booking?.userDetails?.age}</td>
                        <td className={cellClass}>{booking?.userDetails?.maritalStatus}</td>
                        <td className={cellClass}>
                            <button
                                onClick={() => setSelectedBooking(booking)}
                                className="text-[#981D0E] hover:text-[#F5ABAB]"
                                aria-label="View appointment details"
                            >
                                <MoreHorizontalIcon className="h-5 w-5" />
                            </button>
                        </td>
                    </>)}
                />

                {selectedBooking && (
                    <div className="fixed z-[100000] inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4">
                        <div className="bg-white rounded-lg max-w-md w-full p-6">
                            <h2 className="text-xl font-semibold mb-4">Appointment Details</h2>
                            <div className="space-y-4">
                                <DetailRow label="Complaint" value={selectedBooking?.appointmentDetails?.complaint} />
                                <DetailRow label="Duration" value={selectedBooking?.appointmentDetails?.duration} />
                                <DetailRow label="Expectations" value={selectedBooking?.appointmentDetails?.therapyExpectations} />
                                <DetailRow label="Channel" value={selectedBooking?.channel} />
                                <DetailRow
                                    label="Date Created"
                                    value={createdAt?.isValid() ? createdAt.format("YYYY-MM-DD hh:mm A") : null}
                                />
                            </div>

                            <div className="mt-6 flex justify-end">
                                <button
                                    className="px-4 py-2 bg-[#981D0E] text-white rounded-md text-sm font-medium hover:bg-[#F5ABAB]"
                                    onClick={() => setSelectedBooking(null)}
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </Section>
    </>);
}

export default Bookings;
